// setting basepath so icons can be resolved
// see package.json where icons are copied to public folder during npm i
import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path.js';
setBasePath('/assets/sl-icons');